
import { servicesId } from '@/utils/constants'

const getters = {
  getActualize: state => state.actualize,
  // eslint-disable-next-line
  getActualizeIds: (state, getters) => {
    const servicesFieldId = {
      hotels: 'accommodationId',
      transfers: 'vehicleId',
      insurances: 'resultId',
      flights: 'recommendationId'
    }

    let cartServices = {
      hotels: state.hotels.reduce((ids, hotel) => {
        const results = {
          accommodationSearchId: hotel.accommodations.searchId,
          id: hotel.info.id,
          accommodationId: hotel.accommodations.current.id
        }

        const idsWithoutEmpty = Boolean(results.accommodationSearchId)
          && Boolean(results.id)
          && Boolean(results.accommodationId)

        return idsWithoutEmpty ? [...ids, results] : [...ids]
      }, []),
      transfers: state.transfers.reduce((ids, transfer) => {
        const results = {
          searchId: transfer.transfers.searchId,
          id: transfer.transfers.current.transferId,
          vehicleId: transfer.transfers.current.vehicleId
        }

        const idsWithoutEmpty = Boolean(results.searchId)
          && Boolean(results.id)
          && Boolean(results.vehicleId)

        return idsWithoutEmpty ? [...ids, results] : [...ids]
      }, []),
      insurances: state.insurances.reduce((ids, insurance) => {
        const results = {
          searchId: insurance.insurances.searchId,
          resultId: insurance.insurances.current.slug
        }

        const idsWithoutEmpty = Boolean(results.searchId)
          && Boolean(results.resultId)

        return idsWithoutEmpty ? [...ids, results] : [...ids]
      }, []),
      flights: state.flights.reduce((ids, flight) => {
        const results = {
          searchId: flight.aviatickets.searchId,
          recommendationId: flight.aviatickets.current.id
        }

        const idsWithoutEmpty = Boolean(results.searchId)
          && Boolean(results.recommendationId)

        return idsWithoutEmpty ? [...ids, results] : [...ids]
      }, [])
    }

    if (getters.getMainService === 'tours') {
      const tours = Object.keys(cartServices)
        .reduce((tour, service) => ({
          ...tour,
          [service]: cartServices[service].map(item => item[servicesFieldId[service]])
        }), {
          hotels: [],
          transfers: [],
          insurances: [],
          flights: []
        })

      cartServices = {
        tours: [tours],
        hotels: [],
        transfers: [],
        insurances: [],
        flights: []
      }
    }

    const services = Object.keys(cartServices)
      .reduce((ids, service) => (
        cartServices[service].length ? [...ids, servicesId[service]] : [...ids]
      ), [])

    return {
      actualizeId: state.actualize.id,
      currency: getters.getCartPrice.currency,
      ...cartServices,
      services
    }
  }
}

export default getters